import { Button, Container } from '@mantine/core';
import { Link } from "@tanstack/react-location";

function TestScreen() {
    const onTestClicked = () => {

    }

    return (
        <Container>
            <h2>TEST SCREEN</h2>
            <Button onClick={onTestClicked}>Test</Button>

            <Link to="settings">Settings</Link>
        </Container>
    );
}

export default TestScreen;